export const SALE_PROMOTION_PLAN = {
  PRIMARY_KEY: "user_id",
  BASE_PATH: "/volume-promotion/plans/",
  ADD_PATH() {
    return this.BASE_PATH + "add";
  },
  RESET_PASSWORD_PATH(id: string | number) {
    return this.BASE_PATH + id + "/reset-password";
  },
  ADD_PAGE_TITLE: "Add New Volume Promotion Plan",
  LIST_PAGE_TITLE: "Volume Promotion Plan List",
  EDIT_PAGE_TITLE: "Edit Volume Promotion Plan",
  ADD_NEW_TITLE: "Add New Volume Promotion Plan",
  GET_ALL: "/volume-promotion",
  GET_ONE(id: string | number) {
    return `/volume-promotion/edit/${id}`;
  },
  CREATE: "/volume-promotion/create",
  UPDATE: "/volume-promotion/update/",
  DELETE: "/volume-promotion/delete/",
};
